import { Command } from 'commands/Commands';

export class ChangeArticleMetaTitle extends Command {
  type: string = 'BlogArticle.ChangeMetaTitle';
  constructor(id: string, newValue: string) {
    super(newValue, id);
  }
  priority: number = 100;
}
